import { Controller } from "@hotwired/stimulus"

// Turbo Frame更新後にスクロールするコントローラー
export class ScrollToFrameController extends Controller {
  connect() {
    // turbo:frame-load イベントを監視
    this.boundScrollToTarget = this.scrollToTarget.bind(this)
    this.element.addEventListener("turbo:frame-load", this.boundScrollToTarget)
  }

  disconnect() {
    this.element.removeEventListener("turbo:frame-load", this.boundScrollToTarget)
  }

  scrollToTarget() {
    // data-scroll-target属性を持つ要素を探す
    const targetElement = document.querySelector('[data-scroll-target]')
    
    if (targetElement) {
      // 少し余裕を持たせてスクロール（ヘッダー分を考慮）
      const headerOffset = 80
      const elementPosition = targetElement.getBoundingClientRect().top
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      })
    }
  }
}
